import React, { FC } from 'react'

const CardLeft: FC = ({ children }) => <div className='card-container__left'>{children}</div>

export default CardLeft
